import React, { useEffect, useState } from 'react';
import styles from '../styles';
import { Empty, Form, Row, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { CommonValidator, httpCreators } from 'rbh-merchant-core';
import { REPORT_REQUEST_ID_LIST } from '../../redux/report-constant';
import { reportSagas } from '../../redux/report-saga';
import { ReportService } from '../../redux/report-service';
import { RBHBox, RBHButton, RBHTable, RBHText, RBHTextInput } from '../../../../../shared/components';
import metrics from '../../../../../shared/theme/metrics';
import styleText from '../../../../../shared/components/rbh-text/styles';
import { MODAL_TYPE } from '../../../../../redux/general/general-constant';
import { generalCreators } from '../../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../../redux/general/general-reducer';
import { reportCreators } from '../../redux/report-action';
import { REPORT_STATE_KEY, reportStateSelector } from '../../redux/report-reducer';
import './styles.css';

export const AddEditEmailVat: React.FC<Props> = (p) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const [formInvalid, setFormInvalid] = useState(false);
  const emailListVatData = useSelector(reportStateSelector(REPORT_STATE_KEY.EMAIL_LIST_VAT)) as [];

  useEffect(() => {
    form.validateFields();
    return () => {
      if (history.action === 'POP' && p.onSuccessCallBack) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        history.push('/main/report/manage_email');
      }
    };
  }, [history]);

  const vatContentRender = () => {
    return (
      <RBHBox>
        <RBHText data-testid='vatTable-Header' id='vatTable-Header' style={styles.contentHeaderText}
          text={'main.report.addEditEmailVat.table.vat.content'} />
      </RBHBox>
    );
  };

  const checkFormInvalid = () => {
    let invalid = false;
    const errors = form.getFieldsError();
    for (const field of errors) {
      if (field.errors.length > 0) {
        invalid = true;
        break;
      }
    }
    setFormInvalid(invalid);
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const showSuccess = () => {
    dispatch(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_SUCCESS, true));
  };

  const onFinish = () => {
    const resetReload = p.onSuccessCallBack;
    const value = form.getFieldsValue();
    const data = {
      vat: {
        emailTo: value.vatAddEmailTo,
        emailCc: value.vatAddEmailCc
      }
    };
    dispatch(httpCreators.request({
      id: REPORT_REQUEST_ID_LIST.POST_EMAIL_VAT_ADDRESS,
      sagaHandler: reportSagas.postEmailVatAddressHandler as any,
      callbackParams: { resetReload, showSuccess },
      service: ReportService.postEmailVatAddress,
      serviceParams: data
    }));
  };

  const columnsVat = [
    {
      width: metrics.tableHeader.width300,
      title: <FormattedMessage id={'main.report.addEditEmailVat.table.vat.column1'} />,
      render: () => {
        return (
          <RBHBox style={{ width: metrics.tableHeader.width300 }}>
            <RBHText id={'vatAddress'} data-testid={'vatAddress'} style={styleText.textRegularFakeBlack}
              text={'main.report.manageEmail.table.vat.column1.value'} />
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width230,
      title: <FormattedMessage id={'main.report.addEditEmailVat.table.vat.column2'} />,
      render: (value: any, all: any) => {
        return (
          <RBHBox style={{ width: metrics.tableHeader.width230 }}>
            <Form size='large' style={styleText.formText} form={form}>
              <Form.Item className={'addEditEmailVat'} colon={false}
                name={'vatAddEmailTo'} initialValue={all.emailTo ? all.emailTo : ''}>
                <RBHTextInput id={'vatAddEmailTo'} data-testid={'vatAddEmailTo'} style={{ width: '250px' }}
                  disabled={true} maxLength={CommonValidator.Email.maxLength} />
              </Form.Item>
            </Form>
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width230,
      title: <FormattedMessage id={'main.report.addEditEmailVat.table.vat.column3'} />,
      dataIndex: 'emailCc',
      render: (value: any) => {
        return (
          <RBHBox style={{ width: metrics.tableHeader.width230 }}>
            <Form size='large' style={styleText.formText} form={form} onFieldsChange={checkFormInvalid} onFinish={onFinish}>
              <Form.Item className={'addEditEmailVat'} colon={false}
                validateTrigger={['onChange', 'onBlur']}>
                <Form.Item noStyle name='vatAddEmailCc' initialValue={value ? value : ''}
                  rules={[
                    { pattern: CommonValidator.Email.regexPattern,
                      message: <FormattedMessage id={'main.login.email.format.valid'} /> },
                    ({ getFieldValue }) => ({
                      validator(_, formValue) {
                        if (getFieldValue('vatAddEmailTo') === formValue) {
                          return Promise.reject(<FormattedMessage id={'main.report.addEditEmail.error.dupEmail'} />);
                        }
                        return Promise.resolve();
                      }
                    })
                  ]}>
                  <RBHTextInput id={'vatAddEmailCc'} placeholder={'main.report.addEditEmailVat.table.vat.column3.emailCc.placeholder'}
                    onBlur={() => trimFieldValue('vatAddEmailCc')} autoComplete='off' data-testid={'vatAddEmailCc'}
                    style={styles.textBoxEmailCc} maxLength={CommonValidator.Email.maxLength} />
                </Form.Item>
              </Form.Item>
            </Form>
          </RBHBox>
        );
      }
    }
  ];

  const tableEmailListVatRender = () => {
    return (
      <RBHBox style={styles.paddingTop20}>
        <RBHTable
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<span> <FormattedMessage id={'main.table.notFound'} /> </span>} />
          }}
          rowKey={'emailTo'}
          columns={columnsVat}
          dataSource={emailListVatData}
          pagination={false}>
        </RBHTable>
      </RBHBox>
    );
  };

  const remarkRender = () => {
    return (
      <Row justify={'space-between'}>
        <RBHBox>
          <RBHText data-testid='manageEmail-remark' id='manageEmail-remark' style={styles.remarkText}
            text={'main.report.manageEmail.remark'} />
          <RBHText data-testid='manageEmail-remark1' id='manageEmail-remark1' style={styles.remarkText}
            text={'main.report.manageEmail.remark1'} />
          <RBHText data-testid='manageEmail-remark2' id='manageEmail-remark2' style={styles.remarkText}
            text={'main.report.manageEmail.remark2'} />
          <RBHText data-testid='manageEmail-remark3' id='manageEmail-remark3' style={styles.remarkText}
            text={'main.report.manageEmail.remark3'} />
          <RBHText data-testid='manageEmail-remark4' id='manageEmail-remark4' style={styles.remarkText}
            text={'main.report.manageEmail.remark4'} />
        </RBHBox>
        <RBHBox>
          <Space size={'middle'}>
            <RBHButton
              id={'addEditEmailVat-cancel-btn'}
              style={styles.buttonFromCancelGradient}
              type='primary'
              htmlType='button'
              onClick={() => {
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true,
                  clickClosable: false,
                  escClosable: false,
                  onOk: p.onSuccessCallBack,
                  type: MODAL_TYPE.CONFIRM_EDIT
                }));
              }}
              text={'main.report.addEditEmailVat.cancelButton'}
              data-testid={'addEditEmailVat-cancel-btn'} />
            <RBHButton id={'addEditEmailVat-ok-btn'} style={styles.buttonFromConfirmGradient}
              type='primary'
              htmlType='button'
              onClick={() => { onFinish(); }}
              disabled={formInvalid}
              text={'main.report.addEditEmailVat.okButton'}
              data-testid={'addEditEmailVat-ok-btn'} />
          </Space>
        </RBHBox>
      </Row>

    );
  };

  return (
    <RBHBox>
      <RBHBox style={styles.tablesContent}>
        {vatContentRender()}
        {tableEmailListVatRender()}
      </RBHBox>
      {remarkRender()}
    </RBHBox>
  );
};

type Props = {
  onSuccessCallBack?: any;
};
